import React from 'react';
import styles from './TextInput.module.css';

const TextInput = ({ label, value, onChange, placeholder }) => {
  return (
    <div className={styles.textInputContainer}>
      {label && <label className={styles.label}>{label}</label>}
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={styles.textInput}
      />
    </div>
  );
};

export default TextInput;
